import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16.633 13.043l-4.633 -10.043l-7.97 17.275c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l7.265 -2.463l.955 .324","key":"svg-0"}],["path",{"d":"M16 22l5 -5","key":"svg-1"}],["path",{"d":"M21 21.5v-4.5h-4.5","key":"svg-2"}]]

const IconNavigationShare = createReactComponent('outline', 'navigation-share', 'NavigationShare', __iconNode);

export default IconNavigationShare;